const getPrivacyPolicyLink = () => {
  const buildType = process.env.REACT_APP_BUILD_TYPE;

  switch (buildType) {
    case 'BRAMA':
      return 'https://www.bramawgorce.com/polityka-prywatnosci';
    case 'FLISACY':
      return 'https://flisacy.sromowce.pl/rodo';
    case 'POLANA':
      return 'https://www.dlugapolana.pl/polityka-prywatnosci';
    case 'POTOK':
      return 'https://goracypotok.pl/_pliki/polityka-prywatnosci-v11032021,791f8.pdf';
    case 'STARTVELO':
      return 'https://www.startvelo.pl/polityka-prywatnosci';
    case 'RABKOLAND':
      return 'https://www.rabkoland.pl/pl/polityka-prywatnosci';
    default:
      return '#';
  }
};

export default getPrivacyPolicyLink;
